/**
 * A merch listing's variants as the sellers' catalogs write them and the
 * clients read them: an option's identity, and whether a variant's name is
 * a size.
 */

/** Identity is the item and option pair; label punctuation may occur in either. */
export const optionKeyOf = (part: string | null | undefined, name: string): string =>
  JSON.stringify([part?.trim().toLowerCase() ?? "", name.trim().toLowerCase()]);

/** A variant's name that is a size: a letter size (XS, M, XXL, 3XL) or a
 *  number (10, UK 8), whatever its case. */
const SIZE = /^(?:[2-6]?X{0,4}[SL]|M|(?:(?:UK|EU|US) ?)?\d{1,2}(?:\.5)?)$/i;

/** Whether a name is a size (`SIZE`), its letters as a button may space
 *  them ("X L", Black Lounge's) read together. */
export const isSizeName = (name: string): boolean =>
  SIZE.test(name.trim()) || (/^[A-Za-z](?: [A-Za-z])+$/.test(name.trim()) && SIZE.test(name.replace(/\s+/g, "")));
